import { jsx as _jsx } from "react/jsx-runtime";
import './ProductCard.css';
import { Card } from 'antd';
import { productToString } from "../../helpers/productToString";
const ProductCard = (props) => (_jsx(Card, { title: productToString(props.product), className: `product-card product-${props.product}`, size: "small", children: props.children }));
export default ProductCard;
